import { useState } from "react";
import ReactAudioPlayer from "react-audio-player";
import PhotosPexels from "./PhotosPexels";

export default function Dictionary(props) {
  const [input, setInput] = useState("");
  const [wordData, setWordData] = useState(null);
  const apiURL = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;
  const capitalize = (str) =>
    str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : "";

  async function handleSubmit(e) {
    e.preventDefault();
    if (!input.trim()) return;
    try {
      const response = await fetch(`${apiURL}?word=${input}&key=${apiKey}`);
      if (!response.ok) {
        throw new Error("Error fetching word");
      }
      const result = await response.json();
      setWordData(result);
    } catch (error) {
      console.error(error.message);
      setWordData(null);
    }
  }

  function handleChange(e) {
    setInput(e.target.value);
  }

  function showSynonyms() {
    if (
      wordData &&
      wordData.meanings &&
      wordData.meanings[0] &&
      wordData.meanings[0].synonyms &&
      wordData.meanings[0].synonyms.length > 0
    ) {
      return (
        <div>
          <strong className="colorYellow">Synonyms:</strong>{" "}
          {wordData.meanings[0].synonyms.join(", ")}
        </div>
      );
    }
    return null;
  }
  function Phonetic() {
    if (
      wordData &&
      wordData.phonetic &&
      wordData.phonetic[0] &&
      wordData.phonetic[0].text &&
      wordData.phonetic[0].audio &&
      wordData.phonetic[0].audio
    ) {
      return (
        <div>
          Phonetic: {wordData.phonetic}
          <ReactAudioPlayer src={wordData.phonetic.audio} controls />
        </div>
      );
    }

    return null;
  }

  return (
    <div className="box-results">
      <form onSubmit={handleSubmit} className="form">
        <input
          type="text"
          value={input}
          onChange={handleChange}
          className="place-holder-form"
          placeholder="Search for a word"
        />

        <button type="submit" className="form">
          Submit
        </button>
      </form>
      {wordData && Phonetic()}
      {wordData &&
        wordData.meanings &&
        wordData.meanings[0] &&
        wordData.meanings[1].definition &&
        wordData.meanings[2].definition && (
          <div>
            <br />
            <div className="results">
              <div className="Definition">
                <strong> Definition of </strong>{" "}
                <strong className="colorYellow">
                  {" "}
                  {wordData.word && wordData.word.toUpperCase()}
                </strong>{" "}
                <strong>is:</strong>
                <br />
                <br />
                <strong> 1:</strong>{" "}
                {capitalize(wordData.meanings[0].definition)}
                <br />
                <strong> 2:</strong>
                {wordData.meanings[0] &&
                  capitalize(wordData.meanings[1].definition)}
                <br />
                <strong>3:</strong>
                {wordData.meanings[0] &&
                  capitalize(wordData.meanings[2].definition)}
                <br />
              </div>
              <div className="Synonyms">
                {showSynonyms()}
                {wordData.phonetic}
                <a href={wordData.phonetic.audio}> </a>
                <br />
              </div>
            </div>
          </div>
        )}
      {wordData && <PhotosPexels word={wordData.word} />}
    </div>
  );
}
